import {
  clientsContractsListQueryKey,
  clientsImportContractCreateMutation,
  FetchSiAsigContract
} from '@crm/api'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { App, Form, Input, Modal } from 'antd'

import type { ModalProps } from 'antd'

const formName = 'import-contract'

type Props = {
  clientId: number
  onClose: () => void
} & ModalProps

export const ImportContract = ({ clientId, onClose, ...props }: Props) => {
  const { t } = useLocales()
  const [form] = Form.useForm()
  const { notification } = App.useApp()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { mutate, isPending } = useMutation({
    ...clientsImportContractCreateMutation(),
    onError: (error) => showApiErrors(error, form),
    onSuccess: (data) => {
      invalidateQueries([
        clientsContractsListQueryKey({ path: { client_id: String(clientId) } })
      ])

      onClose()
      form.resetFields()
      notification.success({
        message: t('success.success'),
        description: data?.message
      })
    }
  })

  const onSubmit = (values: FetchSiAsigContract) => {
    mutate({
      path: { id: clientId },
      body: values
    })
  }

  return (
    <Modal
      title={t('lead.convert_to_client')}
      cancelText={t('buttons.cancel')}
      onCancel={onClose}
      okText={t('buttons.save')}
      okButtonProps={{ htmlType: 'submit', form: formName }}
      loading={isPending}
      {...props}
    >
      <Form form={form} name={formName} onFinish={onSubmit} layout="vertical">
        <Form.Item
          name="contract_number"
          label={t('lead.contract_number')}
          rules={[{ required: true }]}
        >
          <Input placeholder={t('lead.contract_number')} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
